import React, {Component, Fragment} from 'react';
import {Routes, Route} from 'react-router-dom'
import {withTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import {route} from "../../../routes";
import TranslationsLandingController from "../controllers/TranslationsLandingController";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";

class TranslationsView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.translations.landing.title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route('landing')}>
          {this.props.t('view.translations.landing.breadcrumb')}
        </BreadcrumbsItem>
        <Routes>
          <Route path={route('landing')} exact={true}
                 element={ <TranslationsLandingController />}/>
        </Routes>
      </Fragment>
    );
  }
}

export default withTranslation('local')(TranslationsView);
